RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Branding = Marionette.CompositeView.extend({
        className: 'x-branding',
        childViewContainer: 'ul',
        template: '#brandingTemplate'
    });
});
